module.exports = __webpack_public_path__ + "19e27d348fefc21941e0310a0ec6339b.svg";